import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=1e28106b&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=ts&"
export * from "./TextComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=1e28106b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28106b",
  null
  
)

export default component.exports